import { render, staticRenderFns } from "./productManualDetails.vue?vue&type=template&id=4987ed02&scoped=true"
import script from "./productManualDetails.vue?vue&type=script&lang=js"
export * from "./productManualDetails.vue?vue&type=script&lang=js"
import style0 from "./productManualDetails.vue?vue&type=style&index=0&id=4987ed02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987ed02",
  null
  
)

export default component.exports